import { queryFilter } from 'utils/proptypes';
import base from './baseApi';

const { urls, methods, execute } = base();

export type BookingFailureLogParams = queryFilter & {
   status?: string;
   errorType?: string;
   organizationId?: string;
};

const header = {
   authorization: true,
};

export const getBookingFailureLogs = (params?: queryFilter & BookingFailureLogParams) => {
   const method = methods.GET;
   const url = `${urls.bookingFailureLog.index}`;
   const response = execute(method, url, header, params);

   return response;
};

export const getBookingFailureLog = (logId: string) => {
   const apiEndPoint = `${urls.bookingFailureLog.getById.replace(':id', logId)}`;
   const response = execute(methods.GET, apiEndPoint, header);

   return response;
};

export const updateBookingFailureStatus = ({ payload, id }: { payload: { status: string }; id: string }) => {
   const method = methods.PATCH;
   const url = `${urls.bookingFailureLog.getById.replace(':id', id)}`;

   return execute(method, url, header, payload);
};

export type CreateBookingFailureLogNotePayload = {
   note: string;
   bookingErrorLogId: string;
   statusHistoryId?: string;
};

export const createBookingFailureLogNote = (payload: CreateBookingFailureLogNotePayload) => {
   const method = methods.POST;
   const url = `${urls.bookingFailureLog.notes}`;

   return execute(method, url, header, payload);
};
